import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { TestSummary } from 'libs/end-to-end/src/tests-utils';
import React, { useMemo } from 'react';
import { DimensionPolarChart } from 'apps/sigma2-ui/src/components/focus-area/DimensionPolarChart';
import { DimensionPolarChartData } from 'apps/sigma2-ui/src/components/focus-area/DimensionPolarChart';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { determineTestsForFocusAreaSummaryConsideringFilters } from 'libs/end-to-end/src/tests-utils';

export interface FocusAreaSummaryPolarChartProps {
  testSummary: TestSummary | null;
  dimensions: DimensionDefinition[] | null;
  focusArea: string;
  onDotClick: () => void;
  calibrationFraming: CalibrationFraming;
  metric: string | null;
}

export const FocusAreaSummaryPolarChart = ({
  testSummary,
  dimensions,
  focusArea,
  onDotClick,
  calibrationFraming,
  metric,
}: FocusAreaSummaryPolarChartProps) => {
  const tests = useMemo(
    () =>
      determineTestsForFocusAreaSummaryConsideringFilters({
        focusArea,
        metric,
        testSummary,
      }),
    [testSummary, focusArea, metric],
  );

  const data: DimensionPolarChartData = useMemo(() => {
    return {
      tests,
      dimensions: dimensions ?? [],
    };
  }, [tests, dimensions]);

  return (
    <DimensionPolarChart
      data={data}
      focusArea={focusArea}
      onDotClick={onDotClick}
      calibrationFraming={calibrationFraming}
    />
  );
};
